<template>
  <div class="schedule-item-holder is-exchnage" :class="{ 'is-in-complex': inComplex }">

    <div class="schedule-item">
      <div class="schedule-item__central">
        <div class="schedule-item__central__main">
          <div class="schedule-item__kcal">
            <nuttrema-iconica-kcal
              :text="EntityExchange.Exchange.name"
              :image="getImagePath(EntityExchange)"
              :energyKcal="EntityExchange.energy_kcal">
            </nuttrema-iconica-kcal>
          </div>

          <div class="schedule-item__text">
            <p class="schedule-item---title" style="font-weight: 400; text-transform: uppercase;">
              {{ _get(EntityExchange, 'Exchange.name', '') }}
            </p>

            <p class="schedule-item--serving-size">
              <span v-if="_get(EntityExchange, 'ExchangeServingSize.symbol') === 'g'" class="serving-size__description">
                {{ _get(EntityExchange, 'exchange_weight_gr') | number-format(2) }}g
              </span>
              <span v-else class="serving-size__description">
                {{ _get(EntityExchange, 'ExchangeServingSize.amount', '') | number-format(2) }}
                {{ _get(EntityExchange, 'ExchangeServingSize.title', false) || _get(EntityExchange, 'ExchangeServingSize.description', '') }}
                ({{ _get(EntityExchange, 'exchange_weight_gr') | number-format(2) }}g)
              </span>

              <span v-if="_get(EntityExchange, 'EntityServingSize.symbol') === 'g'" class="serving-size__quantity">
                &#8776; {{ _get(EntityExchange, 'quantity_gr') | number-format(2) }}g {{ $t('label.of') }} <strong>{{ _get(Entity, 'name') }}</strong>
              </span>
              <span v-else class="serving-size__quantity">
                &#8776; {{ _get(EntityExchange, 'entity_amount') | number-format(2) }} {{ _get(EntityExchange, 'EntityServingSize.title') }}  ({{ _get(EntityExchange, 'quantity_gr') | number-format(2) }}g) {{ $t('label.of') }} <strong>{{ _get(Entity, 'name') }}</strong>
              </span>
            </p>

            <p class="schedule-item--category" v-if="!_isEmpty(_get(EntityExchange, 'ExchangeTypeCategory', []))">
              {{ _get(EntityExchange, 'ExchangeTypeCategory.name', '') }}
            </p>
          </div>

          <!-- check permissions for food allergens -->
          <permissions-control-wrapper
             tooltipPlacement="bottom"
             action="permissions.subscribed_plan.food_allergens"
            :clarification="false"
            :permissions="permissions"
            :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.FOOD_ALLERGENS">
            <div slot="allowed" class="schedule-item__allergens" style="margin-right: 2em">
              <nuttrema-allergens-info :allergens="_get(EntityExchange, 'ExchangeAllergens')"></nuttrema-allergens-info>
            </div>
          </permissions-control-wrapper>
          <!-- check permissions for food allergens -->
        </div>
        <!-- end ~ schedule-item__central__main -->

      </div>
      <!-- end ~ schedule-item__central -->

    </div>
    <!-- end ~ schedule-item -->
  </div>
</template>

<script>
import { isEmpty } from 'lodash';

import NuttremaAllergensInfo from 'components/ui/allergens/nuttrema-allergens-info';

import ScheduleTypeAbstract from './cmpt-schedule-type-abstract';

export default {
  name: 'cmpt-schedule-type-stuff-to-eat-exchange',
  mixins: [ScheduleTypeAbstract],
  props: {
    Entity: {
      type: Object,
      required: true,
      default: null,
    },
    EntityExchange: {
      type: Object,
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaAllergensInfo,
  },
  methods: {
    getImagePath(item) {
      return !isEmpty(this.EntityExchange.ExchangeImage) ? `${process.env.IMAGES_ROOT}${item.ExchangeImage.path}${item.ExchangeImage.thumbnails.medium.filename}` : null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/list/schedule-type/cmpt-schedule-type-stuff-to-eat-exchange.vue